const hostname = window.location.hostname;
const externalOrInternal = localStorage.getItem('userType');

// Default environment (LOCAL)
let envConfig = {
  production: false,
  baseUrl: "https://api.dev.cardinalhealth.net/pharma/tnt/epcisvalidator/",
  enabledAut: true,
  appEnv: 'development',
  issuer: 'https://identity.dev.cardinalhealth.net',
  rtsBaseURL: 'https://chpd-dev.track-n-trace.net/rts/public/api',
  rtsUserName: 'chpd_dev_wh',
  clientId: '0oa2dbpw2hur1dDnN0h8',
  redirectUri: 'http://localhost:4200/callback',
  postLogoutRedirectUri: 'http://localhost:4200/checkemail'
};

// Dev environment ()
if ((hostname.includes('epcis-control-center-dev') || hostname.includes('validator-dev') || hostname.includes('fileguard.dev.cardinalhealth.com')) ) {
  envConfig = {
    production: false,
    baseUrl: "https://api.dev.cardinalhealth.net/pharma/tnt/epcisvalidator/",
    enabledAut: true,
    appEnv: 'development',
    issuer: 'https://identity.dev.cardinalhealth.net',
    clientId: '0oa2dbpw2hur1dDnN0h8',
    redirectUri: hostname.includes('epcis-control-center-dev') ? 'https://epcis-control-center-dev.apps.cf.np.gc.cahcloud.net/callback' : "https://fileguard.dev.cardinalhealth.net/login/Logincallback",
    rtsBaseURL: 'https://chpd-dev.track-n-trace.net/rts/public/api',
    rtsUserName: 'chpd_dev_wh',
    postLogoutRedirectUri: 'https://epcis-control-center-dev.apps.cf.np.gc.cahcloud.net/checkemail'
  };
}

// Staging environment
if (
  hostname.includes('epcis-control-center-stg') ||
  hostname.includes('validator-stg') ||
  hostname.includes('fileguard.stg.cardinalhealth.com')

) {
  const isExternalUser = externalOrInternal === 'external';
  envConfig = {
    production: false,
    baseUrl: 'https://api.stage.cardinalhealth.com/pharma/tnt/epcisvalidator/',
    enabledAut: true,
    appEnv: 'stg',
    rtsBaseURL: 'https://chpd-stage-f5.track-n-trace.net/api',
    rtsUserName: 'chpd_perf_wh',
    issuer: isExternalUser
      ? 'https://cardinalpreprdb2b.oktapreview.com/'
      : 'https://identity.stg.cardinalhealth.net',
    clientId: isExternalUser
      ? '0oa2eun4vu3bujkrF0h8'
      : '0oa2dqbz0ttxDTbLV0h8',
    redirectUri: isExternalUser
      ? 'https://fileguard.stg.cardinalhealth.com/login/Logincallback'
      : hostname.includes('epcis-control-center-stg')
        ? 'https://epcis-control-center-stg.apps.cf.np.gc.cahcloud.net/callback'
        : 'https://fileguard.stg.cardinalhealth.com/login/LoginCallback',
    postLogoutRedirectUri: hostname.includes('epcis-control-center-stg')
      ? 'https://epcis-control-center-stg.apps.cf.np.gc.cahcloud.net/checkemail'
      : 'https://fileguard.stg.cardinalhealth.com/checkemail'
  };

}


// Prod environment
if (hostname.includes('epcis-control-center.apps.cf.gc.cahcloud.net') || hostname.includes('fileguard.cardinalhealth.com')) {
  const isExternalUser = externalOrInternal === 'external';
  envConfig = {
    production: true,
    baseUrl: 'https://api.cardinalhealth.com/pharma/tnt/epcisvalidator/',
    enabledAut: true,
    appEnv: 'prod',
    rtsBaseURL: 'https://chpd-f5.track-n-trace.net/api',
    rtsUserName: 'chpd_prod_wh',
    issuer: isExternalUser
    ? 'https://cardinalb2b.okta.com' 
    : 'https://identity.cardinalhealth.net',
    clientId: isExternalUser
    ? '0oa16tj1ngok7AW8M1t8' 
    : '0oa16d4dpbbjTnXfF1t8',
    redirectUri: isExternalUser 
    ? 'https://fileguard.cardinalhealth.com/login/Logincallback'
    : hostname.includes('epcis-control-center.apps.cf.gc.cahcloud.net')
    ? 'https://epcis-control-center.apps.cf.gc.cahcloud.net/callback' 
    : "https://fileguard.cardinalhealth.com/login/Logincallback",
     postLogoutRedirectUri: hostname.includes('epcis-control-center.apps.cf.gc.cahcloud.net') 
     ? 'https://epcis-control-center.apps.cf.gc.cahcloud.net/checkemail'
     : 'https://fileguard.cardinalhealth.com/checkemail'
  };
}
export const environment = envConfig;

